module.exports = __webpack_public_path__ + "assets/img/lock.8634238d.svg";